import React, {useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { setMenuSelected } from '../redux/actions/menuActions';

function Default() {
    const dispatch = useDispatch();

    console.log( "aaa");

    useEffect(()=>{
        dispatch(setMenuSelected("null"));
    }, [])

    return (
        <div>
            <p>&nbsp;</p>
            <h1>Vítejte</h1>
            <p>Home stránka katalogu doporučeného vybavení. Zvolte, které položky chcete administrovat. </p>
            <p>&nbsp;</p>
        </div>
    )
};
export default Default